/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, sku: NonNullable<unknown> }} Error_Barcode_ExistsInputs */

const vi_error_barcode_exists = /** @type {(inputs: Error_Barcode_ExistsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã vạch này đang dùng cho sản phẩm đang hoạt động "${i?.name}" (mã hàng ${i?.sku}). Gỡ mã vạch ở sản phẩm đó hoặc chuyển nó sang ngừng hoạt động rồi lưu lại.`)
};

/**

* @param {Error_Barcode_ExistsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_barcode_exists = /** @type {((inputs: Error_Barcode_ExistsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Barcode_ExistsInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_barcode_exists(inputs)
});